/* ============================================================
   Influx Motion JS
   Scroll reveals and stagger
   ============================================================ */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.addEventListener('DOMContentLoaded', function () {
      var els = document.querySelectorAll('[data-motion]');
      for (var i = 0; i < els.length; i++) {
        els[i].classList.add('is-visible');
        els[i].classList.add('motion-done');
      }
    });
    return;
  }

  /* --- Scroll reveal with IntersectionObserver ------------- */
  function initReveals() {
    var elements = document.querySelectorAll('[data-motion]');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            el.classList.add('is-visible');
            observer.unobserve(el);

            // After reveal transition ends, switch to hover-ready state
            el.addEventListener('transitionend', function handler() {
              el.classList.add('motion-done');
              el.removeEventListener('transitionend', handler);
            }, { once: true });
          }
        });
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.01 }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* --- Stagger indices ------------------------------------ */
  function initStagger() {
    var parents = document.querySelectorAll('[data-motion-stagger]');
    parents.forEach(function (parent) {
      var children = parent.querySelectorAll(':scope > [data-motion]');
      children.forEach(function (child, i) {
        child.style.setProperty('--stagger', i);
      });
    });
  }

  /* --- Init on DOMContentLoaded --------------------------- */
  function init() {
    initStagger();
    initReveals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify editor support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      var els = document.querySelectorAll('[data-motion]');
      for (var i = 0; i < els.length; i++) {
        els[i].classList.add('is-visible');
        els[i].classList.add('motion-done');
      }
    });
  }
})();
